import { ButtonType } from "~pages/player/playerButtons";
import { DOMHelper, View } from "~ui-lib";

export class PlayerControlButton extends View {
  constructor(type: ButtonType) {
    super(DOMHelper.createDivWithParent(null, null, "playerControlButton " + type));
  }
}
